import * as actionTypes from './actionTypes';
import { serviceEditUser, serviceRefreshToken } from './service';
import { openModal } from '@app/src/commons/modal/state/modals/actions';

const fetchEditUserValueRequest = () => ({
  type: actionTypes.FETCH_EDIT_USER_REQUEST
});

const fetchEditUserValueFailure = (errorMessage: string, errorRol?: boolean) => ({
  type: actionTypes.FETCH_EDIT_USER_FAILURE,
  errorMessage,
  errorRol
});

const fetchEditUserValueSuccess = (data: object) => ({
  type: actionTypes.FETCH_EDIT_USER_SUCCESS,
  data
});

const fetchGetRefreshToken = () => ({
  type: actionTypes.FETCH_REFRESHTOKEN_REQUEST
});

export const fetchEditUser = (value: object, url: string): Function => {
  return async (dispatch, getState) => {
    dispatch(fetchEditUserValueRequest());
    const state = getState();
    const userId = state.filterEditUser.idUser;
    try {
      const data = await serviceEditUser.getData({...value, userId}, url);
      dispatch(fetchEditUserValueSuccess(data));
      dispatch(openModal('CREATE_EDIT_SUCCESS_MODAL'));
    } catch (error) {
      if (error.code === 143) {
        dispatch(fetchRefreshToken({...value, userId}, url));
        return;
      }
      if (error.code === 132) {
        dispatch(fetchEditUserValueFailure('Error de validación de rol. Vuelva a iniciar sesión.', true));
        dispatch(openModal('CLOSE_SESSION_MODAL'));
        return;
      }
      if (error.code === 141) {
        dispatch(fetchEditUserValueFailure('No autorizado. No es administrador del usuario de dicho servicio.', true));
        dispatch(openModal('CLOSE_SESSION_MODAL'));
        return;
      }
      showError(dispatch, error);
    }
  };
};

const fetchRefreshToken = (values: Object, url: string) => {
  return async dispatch => {
    dispatch(fetchGetRefreshToken());
    try {
      const refreshToken = localStorage.getItem('refreshtoken');
      const { data } = await serviceRefreshToken.getData(refreshToken);
      const value = await serviceEditUser.getData(values, url, data.accessToken);
      dispatch(fetchEditUserValueSuccess(value));
      dispatch(openModal('CREATE_EDIT_SUCCESS_MODAL'));
    } catch (error) {
      showError(dispatch, error);
    }
  }
};

const showError = (dispatch, error) => {
  if (error.code === 161) {
    dispatch(fetchEditUserValueFailure('El correo electrónico ya se encuentra registrado.'));
    dispatch(openModal('CREATE_EDIT_FAILURE_MODAL'));
    return;
  }
  dispatch(fetchEditUserValueFailure('Se ha producido un error. Hay un problema temporal en el servicio, Inténtalo de nuevo.'));
  dispatch(openModal('CREATE_EDIT_FAILURE_MODAL'));
};
